import axios from "axios";
import { EquipmentImageResponse } from "../../../types/model/warehouse/equipmentImage";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/warehouse/equipment`;

export const uploadEquipmentImage = async (
  equipmentId: number,
  file: File,
): Promise<EquipmentImageResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const formData = new FormData();
  formData.append("fileContent", file);

  const res = await axios.post<EquipmentImageResponse>(
    `${BASE_URL}/${equipmentId}/images`,
    formData,
    {
      headers: {
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};